<script>
import baseMixin from '@/mixins/baseMixin'
import EmptyStateBlock from '../empty-state-block.vue'

export default {
  name: 'DeletePresetConfirmationView',
  components: {
    EmptyStateBlock,
  },
  mixins: [baseMixin],
  props: {
    preset: {
      type: Object,
      required: true,
    },
  },
}
</script>

<template>
  <EmptyStateBlock
    icon="mdi-delete"
    :title="$t('general.orgFilter.dialog.deleteConfirm.title', [preset.title])"
    :description="$t('general.orgFilter.dialog.deleteConfirm.description')"
  >
    <template v-slot:button>
      <div>
        <v-btn text outlined class="mr-2" @click="$emit('cancel')">
          {{ $t('general.cancel') }}
        </v-btn>
        <v-btn text outlined color="error" @click="$emit('delete')">
          {{ $t('general.orgFilter.dialog.deleteConfirm.confirmBtn') }}
        </v-btn>
      </div>
    </template>
  </EmptyStateBlock>
</template>
